import React, { useEffect, useState, useRef, useCallback } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import DatePicker from "react-datepicker";
import Loader from "../../../Utils/Loader";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";

import { Eye } from "lucide-react";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import {
  GET_ALL_TRADE_HISTORY,
  GET_ALL_MANUAL_TRADE_HISTORY,
  TRADE_EXECUTE,
} from "../../../Service/user.service";
import DeltaSocketClient from "../../../Utils/main/DeltaSocket";
import DetailsView from "./DetailsView";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { SET_THEME_DETAILS } from "../../../Service/auth.service";

import { updateTargetAndStoploss } from "../../../Service/admin.service";
import { usePrices } from "../../../context/PriceContext";

const TradeHistory = () => {
  const tabs = [
    { label: "Strategy", value: "Strategy" },
    { label: "Manual", value: "Manual" },
  ];

  const prices = usePrices(); // ✅ FIXED

  // Get user details from localStorage with better error handling
  const getUserDetails = () => {
    try {
      const userDetails = JSON.parse(
        localStorage.getItem("user_details") || "{}"
      );
      const gotodashboard = JSON.parse(
        localStorage.getItem("gotodashboard") || "false"
      );
      const gotodashboardDetails = JSON.parse(
        localStorage.getItem("user_details_goTo") || "{}"
      );

      const { token, user_id, broker } = userDetails;
      const currentUserId = gotodashboard
        ? gotodashboardDetails.user_id
        : user_id;

      const brokerId = gotodashboard
        ? gotodashboardDetails.broker
        : broker;

      return { token, currentUserId, brokerId };
    } catch (error) {
      console.error("Error parsing user details:", error);
      return { token: null, currentUserId: null };
    }
  };
  const { token, currentUserId, brokerId } = getUserDetails();


  // State management
  const [filterModal, setFilterModal] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [paginatedData, setPaginatedData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [tradeHistoryData, setTradeHistoryData] = useState({
    loading: true,
    data: [],
  });
  const [getType, setGetType] = useState("Strategy");
  const [livePrices, setLivePrices] = useState({});
  const [symbolList, setSymbolList] = useState([]);
  const [totalPnl, setTotalPnl] = useState(0);
  const [validationErrors, setValidationErrors] = useState({});
  const [tradeUpdates, setTradeUpdates] = useState({});

  const [editableRows, setEditableRows] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [btnstatus, setBtnstatus] = useState("1");
  const [unrealizedPnl, setUnrealizedPnl] = useState(0);
  const [strategiesList, setStrategiesList] = useState([]);
  const [strategy, setStrategy] = useState("");
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const permission = JSON.parse(localStorage.getItem("permission"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const gotodashboardDetails = JSON.parse(localStorage.getItem("user_details_goTo"));


  // Auto-decimal rounding based on value size
  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 0; // No decimals for big numbers
    } else if (Math.abs(value) >= 1) {
      digits = 2; // 2 decimals for normal numbers
    } else if (Math.abs(value) >= 0.01) {
      digits = 4; // 4 decimals for small numbers
    } else {
      digits = 6; // 8 decimals for very tiny values
    }

    return Number(value.toFixed(digits));
  };

  // Validation function
  const validateTradeValue = (row, fieldName, value) => {
    const livePrice = livePrices[row.symbol] || row.entryPrice;
    const entryPrice = parseFloat(row.entryPrice);
    const numValue = parseFloat(value);

    if (!value || isNaN(numValue)) {
      return ""; // No error for empty values
    }

    const errors = [];

    if (fieldName === "target") {
      if (row.side === "BUY" || row.side === "LE") {
        if (numValue <= livePrice) {
          errors.push(
            `Target should be greater than current price (${livePrice})`
          );
        }
        if (numValue <= entryPrice) {
          errors.push(
            `Target should be greater than entry price (${entryPrice})`
          );
        }
      } else if (row.side === "SELL" || row.side === "SE") {
        if (numValue >= livePrice) {
          errors.push(
            `Target should be less than current price (${livePrice})`
          );
        }
        if (numValue >= entryPrice) {
          errors.push(`Target should be less than entry price (${entryPrice})`);
        }
      }
    }

    if (fieldName === "stoploss") {
      if (row.side === "BUY" || row.side === "LE") {
        if (numValue >= livePrice) {
          errors.push(
            `Stop Loss should be less than current price (${livePrice})`
          );
        }
        if (numValue >= entryPrice) {
          errors.push(
            `Stop Loss should be less than entry price (${entryPrice})`
          );
        }
      } else if (row.side === "SELL" || row.side === "SE") {
        if (numValue <= livePrice) {
          errors.push(
            `Stop Loss should be greater than current price (${livePrice})`
          );
        }
        if (numValue <= entryPrice) {
          errors.push(
            `Stop Loss should be greater than entry price (${entryPrice})`
          );
        }
      }
    }

    return errors.join(". ");
  };

  // Get field value (either from modified state or original data)
  const getFieldValue = (row, fieldName) => {
    return tradeUpdates[row._id]?.[fieldName] || row[fieldName] || "";
  };

  // Get input class name based on validation state
  const getInputClassName = (row, fieldName) => {
    const errorKey = `${row._id}-${fieldName}`;
    const hasError = validationErrors[errorKey];
    return `form-control form-control-sm ${hasError ? "is-invalid" : ""}`;
  };

  // Handle input changes for Target and Stop Loss
  const handleOnChange = (row, e) => {
    const { name, value } = e.target;

    if (!row._id) return;

    // Update the trade values
    setTradeUpdates((prev) => ({
      ...prev,
      [row._id]: {
        ...prev[row._id],
        [name]: value,
      },
    }));

    // Validate the input
    const errorKey = `${row._id}-${name}`;
    const errorMessage = validateTradeValue(row, name, value);

    setValidationErrors((prev) => ({
      ...prev,
      [errorKey]: errorMessage,
    }));
  };

  const calculatePnl = (trade, livePrice) => {
    if (!livePrice) return 0;

    const entryPrice = Number(trade.entryPrice);
    const qty = Number(trade.quantity);

    if (!entryPrice || !qty) return 0;

    let pnl = 0;

    if (trade.side === "BUY" || trade.side === "LE") {
      pnl = (livePrice - entryPrice) * qty;
    } else if (trade.side === "SELL" || trade.side === "SE") {
      pnl = (entryPrice - livePrice) * qty;
    }

    // 🔹 Broker specific adjustment (same as your logic)
    if (brokerId === "2" || permission?.trade_History_DeltaExchange === 1) {
      if (trade.symbol === "BTCUSD") pnl = pnl / 1000;
      if (trade.symbol === "ETHUSD") pnl = pnl / 100;
      if (trade.symbol === "DOGEUSD") pnl = pnl * 100;
      if (trade.symbol === "PAXGUSD") pnl = pnl /1000;
    }

    return pnl;
  };



  // Get date range for API calls
  const getDateRange = () => {
    const today = new Date();
    const startDate = fromDate || new Date(today.setHours(0, 1, 0, 0));
    const endDate = toDate
      ? new Date(toDate.setHours(23, 59, 59, 999))
      : new Date(today.setHours(23, 59, 59, 999));
    return { startDate, endDate };
  };

  // Fetch trade history data
  const fetchTradeHistory = useCallback(async () => {
    if (!token || !currentUserId) return;

    setTradeHistoryData((prev) => ({ ...prev, loading: true }));

    const { startDate, endDate } = getDateRange();
    const apiCall =
      getType === "Strategy"
        ? GET_ALL_TRADE_HISTORY
        : GET_ALL_MANUAL_TRADE_HISTORY;

    try {
      const response = await apiCall(
        {
          user_id: currentUserId,
          startDate,
          endDate,
          getType,
        },
        token
      );

      if (response.status && response.data) {
        setTradeHistoryData({
          loading: false,
          data: response.data,
        });

        const symbols = [
          ...new Set(response.data.map((trade) => trade.symbol)),
        ];
        setSymbolList(symbols);

        const totalRealisedPnl = response.data.reduce((total, trade) => {
          if (trade.extstatus === "CLOSED") {
            return total + calculatePnl(trade);
          }
          return total;
        }, 0);

        // ✅ FIX: Calculate unrealized PnL here
        const totalUnrealisedPnl = response.data.reduce((total, trade) => {
          if (trade.extstatus === "ACTIVE") {
            const livePrice = livePrices[trade.symbol] || trade.entryPrice;
            return total + calculatePnl(trade, livePrice);
          }
          return total;
        }, 0);

        setTotalPnl(totalRealisedPnl);
      } else {
        setTradeHistoryData({ loading: false, data: [] });
        setSymbolList([]);
        setTotalPnl(0);
        setTradeUpdates({});
      }
    } catch (error) {
      console.error("Error fetching trade history:", error);
      setTradeHistoryData({ loading: false, data: [] });
      setSymbolList([]);
      setTotalPnl(0);
    }
  }, [fromDate, toDate, getType, currentUserId, token]);

  useEffect(() => {
    symbolList.forEach((s) => {
      const cached = prices[s];
      if (cached) {
        setLivePrices((prev) => ({ ...prev, [s]: cached?.spot_price }));
      }
    });
  }, [symbolList]);

  // Fetch data on component mount and filter changes
  useEffect(() => {
    fetchTradeHistory();
    getCompanydata();
  }, [fetchTradeHistory]);

  // Handle pagination
  useEffect(() => {
    const startIndex = (page - 1) * sizePerPage;
    const endIndex = startIndex + sizePerPage;
    setPaginatedData(tradeHistoryData.data.slice(startIndex, endIndex));
  }, [page, sizePerPage, tradeHistoryData.data, livePrices]);

  // Handle square off (only for manual trades)
  const handleSquareOff = async (row) => {
    if (row.extstatus !== "ACTIVE") return;

    try {
      const data = `symbol:${row.symbol}|ordertype:${row.side === "BUY" ? "SELL" : "BUY"
        }|quantity:${row.quantity}|price:${livePrices[row.symbol]}|strategy:${row?.strategy
        }|key:${row.key}|category:${row.category
        }|signalType:PANEL_SQUAREOFF|tradeid:${row._id}`;

      const response = await TRADE_EXECUTE(data);

      if (response.status) {
        toast.success(response.message);
        fetchTradeHistory(); // Refresh data after successful square off
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in square off:", error);
      toast.error("Failed to square off trade");
    }
  };

  const handleUpdateRow = async (row) => {
    try {
      const requests = Object.entries(tradeUpdates).map(
        ([tradeId, values]) => ({
          tradeId,
          target: values.target,
          stoploss: values.stoploss,
        })
      );

      if (requests?.length > 0) {
        requests.map(async (data) => {
          const payload = data;

          const response = await updateTargetAndStoploss(payload, token);

          if (response?.status) {
            toast.success("Target & Stoploss updated successfully");

            // Update table data
            setTradeHistoryData((prev) => ({
              ...prev,
              data: prev.data.map((trade) =>
                trade._id === row._id ? { ...trade, ...payload } : trade
              ),
            }));
          } else {
            toast.error(response?.message || "Update failed ❌");
          }
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while updating");
    }
  };

  // Reset filters
  const resetFilters = () => {
    setFromDate(null);
    setToDate(null);
    setTradeUpdates({});
    setValidationErrors({});
    fetchTradeHistory();
  };

  useEffect(() => {
    if (!tradeHistoryData.data?.length) return;

    // force re-render when prices change
    setTradeHistoryData((prev) => ({
      ...prev,
      data: [...prev.data],
    }));
  }, [prices]);


  // Table columns configuration

  const calculatePnL = (trade, livePrice = null) => {
    const entryPrice = Number(trade.entryPrice);
    const exitPrice = Number(trade.exitPrice);
    const qty = Number(trade.quantity);

    if (!entryPrice || qty <= 0) return 0;

    let pnl = 0;

    // ✅ CLOSED TRADE → EXIT PRICE
    if (trade.extstatus === "CLOSED" && exitPrice) {
      pnl =
        trade.side === "BUY" || trade.side === "LE"
          ? (exitPrice - entryPrice) * qty
          : (entryPrice - exitPrice) * qty;
    }

    // ✅ ACTIVE TRADE → LIVE PRICE
    if (trade.extstatus === "ACTIVE" && livePrice) {
      pnl =
        trade.side === "BUY" || trade.side === "LE"
          ? (livePrice - entryPrice) * qty
          : (entryPrice - livePrice) * qty;
    }

    // 🔥 Broker 2 adjustment
    if (brokerId === "2" || permission?.trade_History_DeltaExchange === 1) {
      if (trade.symbol === "BTCUSD") pnl /= 1000;
      if (trade.symbol === "ETHUSD") pnl /= 100;
      if (trade.symbol === "DOGEUSD") pnl *= 100;
      if (trade.symbol === "PAXGUSD") pnl /=1000;
    }

    return pnl;
  };


  useEffect(() => {
    let realized = 0;

    tradeHistoryData.data.forEach((trade) => {
      if (trade.extstatus === "CLOSED") {
        realized += calculatePnL(trade);
      }
    });

    setTotalPnl(realized);
  }, [tradeHistoryData.data]);


  useEffect(() => {
    if (!tradeHistoryData.data?.length) {
      setUnrealizedPnl(0);
      return;
    }

    let total = 0;

    tradeHistoryData.data.forEach((trade) => {
      // ✅ ONLY ACTIVE TRADES
      if (trade.extstatus !== "ACTIVE") return;

      const livePrice = prices?.[trade.symbol]?.spot_price;
      if (!livePrice) return;

      total += calculatePnl(trade, livePrice);
    });

    setUnrealizedPnl(total);
  }, [tradeHistoryData.data, prices]);



  useEffect(() => {
    setUnrealizedPnl(0);

  }, [getType]);


  useEffect(() => {
    if (tradeHistoryData.data?.length > 0) {
      const unique = [
        ...new Set(tradeHistoryData.data.map((item) => item.strategy)),
      ];

      setStrategiesList(unique);
    }
  }, [tradeHistoryData.data]);



  useEffect(() => {
    let data = tradeHistoryData.data;

    if (strategy !== "") {
      data = data.filter((item) => item.strategy === strategy);
    }

    setPage(1);
  }, [strategy, tradeHistoryData.data]);



  const getCompanydata = async () => {
    try {
      const res = await SET_THEME_DETAILS();
      if (res.status) {
        setBtnstatus(res.data[0]?.pnl_position);
      }
    } catch (error) { }
  };
  const getColumns = () => {
    const baseColumns = [
      {
        name: "Entry Time",
        selector: (row) => row.createdAt,
        cell: (row) => (
          <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
        ),
        sortable: true,
        width: "190px",
      },
      {
        name: "Exit Time",
        selector: (row) => row.exitTime,
        cell: (row) => (
          <>{row.exitTime ? fDateTimeSuffix(row.exitTime) : "-"}</>
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Symbol",
        selector: (row) => row.symbol,
        cell: (row) => <>{row.symbol || "-"}</>,
        sortable: true,
        width: "120px",
      },

      {
        name: "Entry Type",
        selector: (row) => row.ordertype,
        cell: (row) => (
          <span
            className={`badge ${row.side === "BUY" || row.side === "LE"
              ? "bg-success"
              : "bg-danger"
              }`}
            style={{ fontSize: "0.9rem" }}
          >
            {row.side === "BUY" || row.side === "LE"
              ? "BUY ENTRY"
              : "SELL ENTRY"}
          </span>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: (brokerId === "2" || permission?.trade_History_DeltaExchange === 1) ? "Lot" : "Quantity",
        selector: (row) =>
          row.quantity !== null ? parseFloat(row.quantity) : "-",
        sortable: true,
        width: "120px",
      },
      {
        name: "Entry Price",
        selector: (row) =>
          row.entryPrice !== null ? roundSmart(row.entryPrice) : "-",
        sortable: true,
        width: "140px",
      },
      {
        name: "Exit Price",
        selector: (row) => {
          const livePrice = prices?.[row.symbol]?.spot_price;
          const displayPrice =
            row.exitPrice ??
            (row.extstatus === "ACTIVE" ? livePrice : null);

          return displayPrice !== null && displayPrice !== undefined
            ? roundSmart(displayPrice)
            : "-";
        },
        cell: (row) => {
          const livePrice = prices?.[row.symbol]?.spot_price;
          const displayPrice =
            row.exitPrice ??
            (row.extstatus === "ACTIVE" ? livePrice : null);

          return displayPrice !== null && displayPrice !== undefined ? (
            <span>{roundSmart(displayPrice)}</span>
          ) : (
            <div
              className="spinner-border spinner-border-sm text-success"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          );
        },
        sortable: true,
        width: "130px",
      },

      {
        name: "P&L",
        selector: (row) => {
          const livePrice = prices?.[row.symbol]?.spot_price;
          return calculatePnL(row, livePrice);
        },
        cell: (row) => {
          const livePrice = prices?.[row.symbol]?.spot_price;
          const pnl = calculatePnL(row, livePrice);

          return (
            <span
              style={{
                color: pnl >= 0 ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              {roundSmart(pnl)}
            </span>
          );
        },
      },



      {
        name: "Strategy",
        selector: (row) => row.strategy,
        cell: (row) => <>{row.strategy || "-"}</>,
        sortable: true,
        width: "130px",
      },
      ...(getType !== "Strategy"
        ? [
          {
            name: "Target",
            selector: (row) => row.target,
            cell: (row) => {
              const value = getFieldValue(row, "target");

              const handleBlur = (e) => {
                const num = parseFloat(e.target.value);
                if (!isNaN(num)) {
                  // format to 2 decimals only on blur
                  handleOnChange(row, {
                    target: { name: "target", value: num },
                  });
                }
              };

              return (
                <input
                  type="number"
                  name="target"
                  step="1"
                  min="0"
                  value={value ?? ""}
                  onChange={(e) => handleOnChange(row, e)}
                  onBlur={handleBlur}
                  className={getInputClassName(row, "target")}
                  placeholder="Target"
                  disabled={!editableRows[row._id]}
                />
              );
            },
            sortable: true,
            width: "150px",
          },
          {
            name: "Stop Loss",
            selector: (row) => row.stoploss,
            cell: (row) => {
              const value = getFieldValue(row, "stoploss");

              const handleBlur = (e) => {
                const num = parseFloat(e.target.value);
                if (!isNaN(num)) {
                  // format to 2 decimals only on blur
                  handleOnChange(row, {
                    target: { name: "stoploss", value: num },
                  });
                }
              };

              return (
                <input
                  type="number"
                  name="stoploss"
                  step="0.01"
                  min="0"
                  value={value ?? ""}
                  onChange={(e) => handleOnChange(row, e)}
                  onBlur={handleBlur}
                  className={getInputClassName(row, "stoploss")}
                  placeholder="Stop Loss"
                  disabled={!editableRows[row._id]}
                />
              );
            },
            sortable: true,
            width: "150px",
          },

          {
            name: "Action",
            cell: (row) => (
              <div>
                {editableRows[row._id] ? (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      handleUpdateRow(row);
                      setEditableRows((prev) => ({
                        ...prev,
                        [row._id]: false,
                      }));
                    }}
                  >
                    Confirm
                  </button>
                ) : (
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() =>
                      setEditableRows((prev) => ({
                        ...prev,
                        [row._id]: true,
                      }))
                    }
                    disabled={row.extstatus !== "ACTIVE"}
                  >
                    {row.extstatus !== "ACTIVE" ? "Close" : "Edit"}
                  </button>
                )}
              </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: "150px",
          },
        ]
        : []),
    ];

    // Add Square Off button only for Manual tab
    if (getType.includes("Manual")) {
      baseColumns.push({
        name: "Square Off",
        cell: (row) => (
          <button
            className="btn btn-outline-danger btn-sm"
            disabled={row.extstatus !== "ACTIVE"}
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "You want to square off this trade!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, square off it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  handleSquareOff(row);
                }
              });
            }}
            style={{
              opacity: row.extstatus === "ACTIVE" ? 1 : 0.5,
              cursor: row.extstatus === "ACTIVE" ? "pointer" : "not-allowed",
              fontWeight: "bold",
              borderRadius: "4px",
              padding: "2px 10px",
              minWidth: "90px",
            }}
            title={
              row.extstatus !== "ACTIVE"
                ? "Trade already closed"
                : "Square Off this trade"
            }
          >
            {row.extstatus !== "ACTIVE" ? "Trade Closed" : "Square Off"}
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "150px",
      });
    }

    // Add Details View column
    baseColumns.push({
      name: "Details View",
      cell: (row) => (
        <Eye
          className="mx-2"
          onClick={() => {
            setRowData(row);
            setShowModal(true);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    });

    return baseColumns;
  };



  return (
    <Content
      Page_title="Trade History"
      button_status={false}
      button_status1={true}
    >
      {/* Centered Tabs */}
      <div className="d-flex justify-content-center mb-3">
        <ul className={`nav nav-tabs ${tabs.length === 2 ? "two-tabs" : ""}`}>
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.value}>
              <button
                className={`nav-link ${getType === tab.value ? "active" : ""}`}
                onClick={() => setGetType(tab.value)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Filter and Reset Buttons */}
      <div className="row mb-3 align-items-end filter-row">
        <div className="col-md-3 col-12 mb-2">
          <label className="form-label">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search by symbol or strategy..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="col-md-2 col-12 mb-2">
          <label className="form-label">Strategy</label>
          <select
            className="form-select"
            value={strategy}
            onChange={(e) => setStrategy(e.target.value)}
          >
            <option value="">All Strategies</option>

            {strategiesList.map((strat, i) => (
              <option key={i} value={strat}>
                {strat}
              </option>
            ))}
          </select>
        </div>


        {(gotodashboard == true || permission.updatedatefilterpermission === 1) && (
          <>
            <div className=" col-md-3 mb-2 col-5">
              <label className="form-label">From Date</label>

              <DatePicker
                className="form-control"
                selected={fromDate}
                onChange={(date) => setFromDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select From Date"
              />
            </div>
            <div className=" col-md-3 mb-2 col-5">
              <label className="form-label">To Date</label>

              <DatePicker
                className="form-control"
                selected={toDate}
                onChange={(date) => setToDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select To Date"
              />
            </div>
          </>)}

        {/* <div className=" col-md-3 mb-2 col-5">
          <label className="form-label">From Date</label>

          <DatePicker
            className="form-control"
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select From Date"
          />
        </div>
        <div className=" col-md-3 mb-2 col-5">
          <label className="form-label">To Date</label>

          <DatePicker
            className="form-control"
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select To Date"
          />
        </div> */}

        <div className="col-md-1 mb-2 col-2">
          <button
            className="btn btn-primary mt-2 mt-md-0"
            onClick={resetFilters}
          >
            <i className="bi bi-arrow-clockwise"></i>
          </button>
        </div>
      </div>

      {/* Total P&L Display */}
      {btnstatus === "0" && (
        <div
          className=" alert alert-warning mt-3 d-flex flex-wrap justify-content-between justify-content-md-start align-items-center"
          style={{
            borderTop: "1px solid #ddd",
            paddingTop: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
            padding: "10px 15px",
          }}
        >
          {/* Realized P&L */}
          <div className="realized-text ">
            <h6 className="mb-1 fw-semibold">Realized P&L</h6>
            <span
              className="ms-1"
              style={{
                color: Number(totalPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              :  {Number(roundSmart(totalPnl || 0))}
            </span>
          </div>

          {/* Unrealized P&L */}
          <div className="realized-text ms-3">
            <h6 className="mb-1 fw-semibold fs-6">UnRealized P&L</h6>
            <span
              className="ms-1"
              style={{
                color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              :  {Number(roundSmart(unrealizedPnl || 0))}
            </span>
          </div>
        </div>
      )}

      {/* Main Content */}
      {tradeHistoryData.loading ? (
        <Loader />
      ) : (
        <div className="">
          <Table
            columns={getColumns()}
            data={tradeHistoryData.data.filter((row) => {
              const search = searchTerm.toLowerCase();
              return (
                row.symbol?.toLowerCase().includes(search) ||
                row.strategy?.toLowerCase().includes(search) ||
                row.side?.toLowerCase().includes(search)
              );
            })}
            waterMark={true}
          />
          {btnstatus == "1" && (
            <div className="mt-3 d-flex justify-content-end realized-text alert alert-warning">
              <h6>
                Realized P&L:{" "}
                <span style={{ color: totalPnl >= 0 ? "green" : "red" }}>
                 {Number(roundSmart(totalPnl || 0))}
                </span>
              </h6>
              <h6 className="ms-4">
                UnRealized P&L:{" "}
                <span
                  style={{
                    color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                  }}
                >
                  {Number(roundSmart(unrealizedPnl || 0))}
                </span>
              </h6>
            </div>
          )}
        </div>
      )}

      {/* Details View Modal */}
      <DetailsView
        showModal={showModal}
        setshowModal={setShowModal}
        tradeHistoryData={rowData}
      />

      {/* Disclaimer */}
      <div
        className="alert alert-warning bg-transparent mt-3"
        style={{ fontSize: "12px" }}
      >
        <p>
          Note: This result is valid for today only. We do not directly or
          indirectly make any reference to the past or expected future
          return/performance of the algorithm.
        </p>
        <p>
          सभी प्रतिभूतियां एल्गो ट्रेडिंग सिस्टम बाजार जोखिमों के अधीन हैं और इस
          बात का कोई आश्वासन नहीं दिया जा सकता है कि उपयोगकर्ता के उद्देश्यों को
          आज के प्रदर्शन के आधार पर प्राप्त किया जाएगा। यह परिणाम केवल आज के लिए
          मान्य है।
        </p>
      </div>
    </Content>
  );
};

export default TradeHistory;
